<script setup lang="ts">
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import i18n from '@/lang/i18n';

type headerType = {
  isTitle: boolean,
  keyName: string,
  labelPath: string,
  class: string,
}

const props = defineProps<{
    headers: headerType[]
    deliveryPlan?: every24HoursPreviewType
  }>();

function labelOrValue(header: headerType) {
  if (!header.labelPath && props.deliveryPlan) {
    return props.deliveryPlan[header.keyName]
  }
  return i18n.global.t(header.labelPath)
}
</script>
<template>
  <thead>
    <tr>
      <template v-for="header in props.headers" :key="header">
        <th :class="header.class">
          <h4
            v-if="header.isTitle"
            class="font-weight-bold my-1"
          >
            {{ i18n.global.t(header.labelPath) }}
          </h4>
          <div v-else>
            {{ labelOrValue(header) }}
          </div>
        </th>
      </template>
    </tr>
  </thead>
</template>
